'use strict';

var SeasonalityReviewMonthCalendarDirective = function SeasonalityReviewMonthCalendarDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/seasonality-review-month-calendar.html'),
    controller: 'SeasonalityReviewMonthCalendarController',
    scope: {
      date: '=',
      dateToColorMap: '='
    }
  };
};
SeasonalityReviewMonthCalendarDirective.$inject = [];
module.exports = SeasonalityReviewMonthCalendarDirective;